module.exports = __webpack_public_path__ + "img/dark_wheelchair.8eb78222.png";